import { useQuery } from '@tanstack/react-query';
import { useAtom } from 'jotai';
import { getAnalyticsAPI } from 'src/api/orgs/getAnalyticsAPI';
import {
  orgCartAnalyticsEndDateAtom,
  orgCartAnalyticsSelectedRequestersAtom,
  orgCartAnalyticsSelectedVendorsAtom,
  orgCartAnalyticsStartDateAtom,
} from 'src/store';
import { useGetVendorList } from '../useGetVendorList';
import { useGetAllActiveAndRemovedUsers } from './useGetAllActiveAndRemovedUsers';

export const useGetAnalytics = () => {
  const [startDate] = useAtom(orgCartAnalyticsStartDateAtom);
  const [endDate] = useAtom(orgCartAnalyticsEndDateAtom);
  const [selectedRequesters] = useAtom(orgCartAnalyticsSelectedRequestersAtom);
  const [selectedVendors] = useAtom(orgCartAnalyticsSelectedVendorsAtom);

  const usersQuery = useGetAllActiveAndRemovedUsers();
  const vendorListQuery = useGetVendorList();

  // If all vendors are selected, we will send 'all' to the API.
  return useQuery({
    queryKey: [
      'analytics',
      startDate,
      endDate,
      selectedRequesters,
      selectedVendors,
    ],
    queryFn: () =>
      getAnalyticsAPI({
        startDate,
        endDate,
        requesters:
          selectedRequesters.length === usersQuery.data?.length
            ? 'all'
            : selectedRequesters,
        vendors:
          selectedVendors.length === vendorListQuery.data?.length
            ? 'all'
            : selectedVendors,
      }),
    enabled: false,
    retry: false,
  });
};
